/** Client dashboard section definitions and test ids. */

export const CLIENT_DASHBOARD_TEST_ID = 'client-dashboard';
export const CLIENT_DASHBOARD_HERO_TEST_ID = 'client-dashboard-hero';
export const CLIENT_STATUS_SUMMARY_TEST_ID = 'client-status-summary';
export const CLIENT_PREMIUM_PLACEHOLDER_TEST_ID = 'client-premium-placeholder';

export const CLIENT_STATUS_METRICS = [
  {
    id: 'saved',
    labelKey: 'client.stat_saved_homes',
    defaultLabel: 'Saved homes',
    testId: 'client-stat-saved',
  },
  {
    id: 'requests',
    labelKey: 'client.stat_active_requests',
    defaultLabel: 'Active requests',
    testId: 'client-stat-requests',
  },
  {
    id: 'viewings',
    labelKey: 'client.stat_upcoming_viewings',
    defaultLabel: 'Upcoming viewings',
    testId: 'client-stat-viewings',
  },
  {
    id: 'messages',
    labelKey: 'client.stat_unread_messages',
    defaultLabel: 'Unread messages',
    testId: 'client-stat-messages',
  },
];

export const CLIENT_DASHBOARD_SECTIONS = [
  {
    id: 'favorites',
    href: '/favorites',
    labelKey: 'client.dash_saved_homes',
    descKey: 'client.dash_saved_homes_desc',
    testId: 'client-dash-favorites',
    accent: 'gold',
    featured: true,
  },
  {
    id: 'requests',
    href: '/bookings',
    labelKey: 'client.dash_booking_requests',
    descKey: 'client.dash_booking_requests_desc',
    testId: 'client-dash-requests',
    accent: 'blue',
    featured: true,
  },
  {
    id: 'appointments',
    href: '/bookings',
    labelKey: 'client.dash_viewing_appointments',
    descKey: 'client.dash_viewing_appointments_desc',
    testId: 'client-dash-appointments',
    accent: 'blue',
  },
  {
    id: 'messages',
    href: '/notifications',
    labelKey: 'client.dash_messages',
    descKey: 'client.dash_messages_desc',
    testId: 'client-dash-messages',
    accent: 'slate',
  },
  {
    id: 'journey',
    href: '/journey',
    labelKey: 'client.dash_journey',
    descKey: 'client.dash_journey_desc',
    testId: 'client-dash-journey',
    accent: 'gold',
  },
  {
    id: 'alerts',
    href: '/alerts',
    labelKey: 'client.dash_saved_searches',
    descKey: 'client.dash_saved_searches_desc',
    testId: 'client-dash-alerts',
    accent: 'slate',
  },
  {
    id: 'profile',
    href: '/settings',
    labelKey: 'client.dash_profile_settings',
    descKey: 'client.dash_profile_desc',
    testId: 'client-dash-profile',
    accent: 'warm',
  },
];

export function clientDashboardSectionIds() {
  return CLIENT_DASHBOARD_SECTIONS.map((section) => section.id);
}

export function buildClientStatusSummary(counts = {}) {
  return CLIENT_STATUS_METRICS.map((metric) => ({
    ...metric,
    value: counts[metric.id] ?? '—',
  }));
}

export const CLIENT_PREMIUM_COMING_SOON_BADGE_TEST_ID = 'client-premium-coming-soon-badge';
export const CLIENT_HERO_BROWSE_CTA_TEST_ID = 'client-hero-browse-cta';
export const CLIENT_PREMIUM_UNAVAILABLE_TEST_ID = 'client-premium-unavailable-note';

export const CLIENT_PREMIUM_FUTURE_DURATIONS = [
  { id: '1m', labelKey: 'client.premium_duration_1m', defaultLabel: '1 month' },
  { id: '3m', labelKey: 'client.premium_duration_3m', defaultLabel: '3 months' },
  { id: '6m', labelKey: 'client.premium_duration_6m', defaultLabel: '6 months' },
  { id: '12m', labelKey: 'client.premium_duration_12m', defaultLabel: '12 months' },
];

export const PREMIUM_CLIENT_BENEFITS = [
  {
    id: 'early_listings',
    labelKey: 'client.premium_benefit_early_listings',
    defaultLabel: 'Early listing awareness',
  },
  {
    id: 'saved_search_alerts',
    labelKey: 'client.premium_benefit_saved_search_alerts',
    defaultLabel: 'Saved-search alerts',
  },
  {
    id: 'location_insights',
    labelKey: 'client.premium_benefit_location_insights',
    defaultLabel: 'Enhanced location insights',
  },
  {
    id: 'relocation_guidance',
    labelKey: 'client.premium_benefit_relocation_guidance',
    defaultLabel: 'Relocation guidance',
  },
  {
    id: 'request_organization',
    labelKey: 'client.premium_benefit_request_organization',
    defaultLabel: 'Viewing and request organization',
  },
  {
    id: 'ai_concierge',
    labelKey: 'client.premium_benefit_ai_concierge',
    defaultLabel: 'Premium AI concierge (coming soon)',
  },
];
